import React from 'react'
import { Svg, SvgProps } from '@pancakeswap/uikit'

const Prizes: React.FC<SvgProps> = (props) => {
  return (
    <Svg viewBox="0 0 387 111" {...props}>
      <ellipse cx="140.426" cy="29.5931" rx="7.74" ry="6.08143" fill="#C9C9C9" />
      <path
        d="M9.95179 43.9672L0.553223 47.8372L1.03901 45.7321C1.78993 42.4781 3.80274 39.6557 6.63465 37.8857H16.5861L9.95179 43.9672Z"
        fill="#C9C9C9"
      />
      <path
        d="M17.6916 29.5931C25.4316 23.5117 29.0346 23.5117 35.383 23.5117L141.53 23.5121C143.189 23.5121 145.953 25.7269 144.847 26.8326L130.476 41.2036H8.84438C6.63439 41.2036 4.20647 40.0976 6.41811 37.8862L17.6916 29.5931Z"
        fill="url(#podium_paint0_linear)"
      />
      <path
        d="M148.166 29.0404C148.166 27.0702 145.136 26.541 143.743 27.9341L130.474 41.2028V101.464L134.897 99.8057L142.637 92.0657C145.333 89.37 146.847 85.7138 146.847 81.9015L148.166 29.0404Z"
        fill="#908D8D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M120.523 104.262L120.523 104.215C125.884 103.937 130.182 99.6385 130.46 94.2773L130.477 94.2773C130.525 99.2882 134.897 99.8059 136.003 98.7002C131.377 103.326 123.84 104.229 122.181 104.229C121.618 104.229 121.064 104.24 120.523 104.262Z"
        fill="#7D7D7D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M130.508 51.1543H130.46C130.182 45.7931 125.884 41.4949 120.523 41.2169V41.2002C125.534 41.1526 129.859 40.4654 132.118 39.4692C131.135 41.4841 130.474 45.2197 130.474 49.4957C130.474 50.0588 130.486 50.6128 130.508 51.1543Z"
        fill="#C9C9C9"
      />
      <path
        d="M0.942492 49.5973C0.716647 45.3063 4.13513 41.7031 8.43213 41.7031H122.474C126.616 41.7031 129.974 45.061 129.974 49.2031V96.2288C129.974 100.371 126.616 103.729 122.474 103.729H10.9072C6.91821 103.729 3.62718 100.606 3.41753 96.623L0.942492 49.5973Z"
        fill="url(#podium_paint1_linear)"
        stroke="url(#podium_paint2_linear)"
      />
      <ellipse rx="7.74" ry="4.4631" transform="matrix(-1 0 0 1 246.574 49.4631)" fill="#FBAC63" />
      <path
        d="M376.621 63.9444L386 69L386.258 66.5746C386.711 62.3272 384.66 58.2026 381 56H370L376.621 63.9444Z"
        fill="#FBAC63"
      />
      <path
        d="M369.308 49.4631C361.568 45 357.965 45 351.617 45L245.47 45.0003C243.811 45.0003 241.047 46.6257 242.153 47.4372L256.524 57.9839H378.156C380.366 57.9839 382.794 57.1722 380.582 55.5493L369.308 49.4631Z"
        fill="#F7D29B"
      />
      <path
        d="M238.834 49.0575C238.834 47.6116 241.864 47.2232 243.257 48.2456L256.526 57.9834V102.209L252.103 100.991L244.363 95.3112C241.667 93.3328 240.153 90.6496 240.153 87.8518L238.834 49.0575Z"
        fill="#AE5714"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M266.477 104.262L266.477 104.228C261.116 104.023 256.818 100.869 256.54 96.9346L256.523 96.9346C256.475 100.612 252.103 100.992 250.997 100.18C255.623 103.575 263.16 104.238 264.819 104.238C265.382 104.238 265.936 104.246 266.477 104.262Z"
        fill="#AE5714"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M256.492 65.287H256.54C256.818 61.3524 261.116 58.1981 266.477 57.994V57.9817C261.466 57.9469 257.141 57.4425 254.882 56.7114C255.865 58.1901 256.526 60.9316 256.526 64.0698C256.526 64.483 256.514 64.8896 256.492 65.287Z"
        fill="#FBAC63"
      />
      <path
        d="M385.887 66.5199C386.198 62.1776 382.759 58.4834 378.406 58.4834H264.526C260.384 58.4834 257.026 61.8413 257.026 65.9834V96.2374C257.026 100.38 260.384 103.737 264.526 103.737H376.236C380.17 103.737 383.435 100.698 383.717 96.7739L385.887 66.5199Z"
        fill="url(#podium_paint3_linear)"
        stroke="url(#podium_paint4_linear)"
      />
      <path d="M142 29.5H120.5C120.187 21.373 123.937 13.6227 130.504 8.82412L133 7H142V29.5Z" fill="#FFDB41" />
      <path d="M246 30H268V29.3389C268 21.3756 264.306 13.8628 258 9L246 7V30Z" fill="#FFD11F" />
      <path
        d="M121.08 30.538C120.775 22.8772 126.903 16.5 134.569 16.5H254.244C261.978 16.5 268.132 22.9856 267.725 30.7095L264.199 97.7096C263.821 104.88 257.898 110.5 250.717 110.5H137.242C129.995 110.5 124.041 104.779 123.752 97.538L121.08 30.538Z"
        fill="url(#podium_paint5_linear)"
        stroke="url(#podium_paint6_linear)"
      />
      <path
        d="M130.47 8.71637C127.255 10.9531 128.838 16 132.754 16H255.114C259.043 16 260.617 10.9279 257.379 8.7031L249.061 2.98817C246.228 1.04186 242.871 0 239.434 0H148.331C144.86 0 141.473 1.06247 138.623 3.04461L130.47 8.71637Z"
        fill="url(#podium_paint7_linear)"
      />
      <path
        d="M189.694 88.0002V88.5002H190.194H202.446H202.946V88.0002V38.2319V37.6514L202.372 37.7375L182.054 40.7814L181.628 40.8452V41.2759V51.5491V52.1357L182.207 52.0428L189.694 50.842V88.0002Z"
        fill="#EB8C00"
        stroke="url(#podium_paint8_linear)"
      />
      <path
        d="M157.198 55.2339C157.325 54.7383 157.467 54.2388 157.624 53.7358L157.49 53.2379C156.626 50.0099 158.541 46.692 161.769 45.8271L163.347 45.4043L163.764 45.2926L163.876 45.7096L164.351 47.4828C165.185 50.5978 163.431 53.7964 160.406 54.7939C159.991 56.1581 159.697 57.4935 159.505 58.7905C160.622 57.395 162.343 56.5056 164.27 56.518L165.308 56.5246L165.74 56.5274L165.737 56.9591L165.729 58.2329C165.707 61.5746 162.981 64.2663 159.639 64.2449L159.241 64.2423C159.317 65.7807 159.514 67.2281 159.782 68.5624C160.43 66.7617 161.921 65.2974 163.91 64.7643L165.176 64.4251L165.593 64.3134L165.705 64.7304L165.972 65.728C166.837 68.956 164.922 72.2739 161.694 73.1388L161.134 73.2889C161.414 74.0387 161.697 74.7026 161.958 75.2705C162.524 76.2643 163.132 77.1882 163.768 78.0468C163.571 76.2702 164.16 74.4239 165.531 73.0703L166.27 72.341L166.577 72.0377L166.88 72.3449L167.775 73.2514C170.123 75.6295 170.098 79.4606 167.72 81.8084L167.437 82.0884C169.161 83.6502 170.933 84.8705 172.579 85.8159L157.198 55.2339ZM157.198 55.2339C156.564 53.7681 155.355 52.5534 153.738 51.9565L152.487 51.4944L152.082 51.3449L151.932 51.7499L151.834 52.0166C150.676 55.1516 152.28 58.6313 155.415 59.7886L156.355 60.1357C156.295 60.8137 156.259 61.4802 156.244 62.1343C155.09 60.5543 153.192 59.5623 151.091 59.6538L150.485 59.6801L150.054 59.6989L150.073 60.1302L150.163 62.2159C150.309 65.5545 153.133 68.1433 156.472 67.998L156.658 67.9899C156.805 68.8878 156.984 69.7437 157.183 70.5526C155.691 69.3307 153.641 68.8416 151.649 69.4235L151.268 69.5348L150.853 69.6559L150.974 70.0703L151.442 71.6703C152.371 74.8508 155.682 76.6874 158.865 75.8048C159.012 76.0845 159.162 76.3596 159.314 76.63C159.373 76.7561 159.431 76.8778 159.487 76.9951C159.51 77.0433 159.533 77.0908 159.556 77.1375C158.087 76.5746 156.401 76.5812 154.858 77.2918L153.647 77.8502L153.254 78.0308L153.435 78.4229L153.554 78.6811C154.953 81.7163 158.547 83.0431 161.582 81.6447L162.492 81.2252C162.929 81.7472 163.375 82.244 163.827 82.7171C161.893 82.4158 159.85 83.056 158.429 84.6069L158.019 85.0536L157.728 85.3719L158.046 85.6636L159.585 87.0742C162.048 89.3323 165.876 89.1657 168.134 86.7022L168.26 86.5645C169.228 87.2597 170.183 87.8656 171.1 88.3922C171.254 88.481 171.408 88.5676 171.56 88.652C171.997 88.8938 172.521 88.8923 172.957 88.665C174.027 88.1062 174.026 86.5743 172.955 86.017L172.68 85.8741L172.579 85.8164L157.198 55.2339Z"
        fill="#EB8C00"
        stroke="url(#podium_paint9_linear)"
        strokeWidth="0.863409"
        strokeLinecap="round"
      />
      <path
        d="M232.306 55.5401C232.179 55.0444 232.037 54.5449 231.88 54.042L232.013 53.544C232.878 50.3161 230.963 46.9982 227.735 46.1332L226.157 45.7104L225.74 45.5987L225.628 46.0157L225.153 47.789C224.318 50.9039 226.073 54.1026 229.098 55.1C229.513 56.4642 229.807 57.7996 229.999 59.0967C228.882 57.7011 227.161 56.8118 225.234 56.8241L224.196 56.8308L223.764 56.8336L223.767 57.2653L223.775 58.539C223.796 61.8808 226.523 64.5724 229.865 64.551L230.263 64.5485C230.187 66.0868 229.99 67.5343 229.722 68.8685C229.073 67.0679 227.583 65.6035 225.594 65.0705L224.328 64.7313L223.911 64.6195L223.799 65.0365L223.532 66.0342C222.667 69.2621 224.582 72.58 227.81 73.445L228.37 73.5951C228.089 74.3448 227.807 75.0088 227.546 75.5766C226.98 76.5705 226.372 77.4944 225.736 78.3529C225.933 76.5763 225.344 74.7301 223.973 73.3764L223.234 72.6471L222.927 72.3438L222.624 72.651L221.729 73.5575C219.381 75.9356 219.406 79.7668 221.784 82.1146L222.067 82.3946C220.343 83.9563 218.571 85.1767 216.925 86.1221L232.306 55.5401ZM232.306 55.5401C232.939 54.0742 234.149 52.8596 235.766 52.2626L237.017 51.8006L237.422 51.6511L237.572 52.0561L237.67 52.3228C238.827 55.4578 237.224 58.9374 234.089 60.0947L233.149 60.4418C233.209 61.1199 233.245 61.7864 233.26 62.4405C234.414 60.8604 236.312 59.8685 238.413 59.9599L239.019 59.9863L239.45 60.005L239.431 60.4363L239.341 62.522C239.195 65.8607 236.371 68.4494 233.032 68.3042L232.846 68.296C232.698 69.1939 232.52 70.0499 232.321 70.8587C233.813 69.6368 235.863 69.1477 237.855 69.7296L238.236 69.841L238.651 69.962L238.529 70.3764L238.062 71.9764C237.133 75.157 233.822 76.9935 230.639 76.111C230.492 76.3907 230.342 76.6657 230.19 76.9361C230.131 77.0622 230.073 77.184 230.017 77.3013C229.994 77.3495 229.971 77.3969 229.948 77.4437C231.417 76.8807 233.103 76.8873 234.646 77.598L235.857 78.1563L236.249 78.337L236.069 78.7291L235.95 78.9873C234.551 82.0224 230.957 83.3492 227.922 81.9508L227.012 81.5314C226.575 82.0533 226.129 82.5502 225.677 83.0233C227.61 82.7219 229.654 83.3622 231.075 84.9131L231.485 85.3598L231.776 85.678L231.458 85.9697L229.919 87.3804C227.455 89.6384 223.628 89.4719 221.37 87.0084L221.244 86.8706C220.276 87.5658 219.321 88.1718 218.404 88.6983C218.25 88.7871 218.096 88.8737 217.944 88.9581C217.507 89.2 216.982 89.1985 216.547 88.9711C215.477 88.4123 215.478 86.8804 216.549 86.3231L216.823 86.1803L216.925 86.1225L232.306 55.5401Z"
        fill="#EB8C00"
        stroke="url(#podium_paint10_linear)"
        strokeWidth="0.863409"
        strokeLinecap="round"
      />
      <path
        d="M321.138 93.3508C320.483 93.3508 319.711 93.304 318.823 93.2105C317.934 93.1169 317.057 92.9883 316.192 92.8246C315.35 92.6375 314.649 92.4271 314.087 92.1932V87.4929C315.046 87.9372 316.075 88.2529 317.174 88.44C318.273 88.6271 319.302 88.7206 320.261 88.7206C321.734 88.7206 322.833 88.5218 323.558 88.1243C324.306 87.7268 324.681 87.0018 324.681 85.9495C324.681 85.1311 324.365 84.5348 323.734 84.1606C323.126 83.7865 322.237 83.5994 321.068 83.5994H317.385L317.77 79.6357H320.822C322.015 79.6357 322.88 79.4486 323.418 79.0745C323.956 78.6769 324.225 78.0455 324.225 77.1803C324.225 76.3618 323.897 75.7422 323.242 75.3212C322.611 74.9003 321.582 74.6898 320.156 74.6898C319.15 74.6898 318.133 74.8068 317.104 75.0406C316.075 75.2511 315.186 75.5317 314.438 75.8825V71.2523C315.257 70.9249 316.274 70.6443 317.49 70.4105C318.729 70.1766 319.969 70.0597 321.208 70.0597C324.061 70.0597 326.236 70.6677 327.732 71.8837C329.252 73.0763 330.012 74.608 330.012 76.4788C330.012 77.5545 329.778 78.56 329.311 79.4954C328.866 80.4308 328.177 81.1323 327.241 81.6C328.317 81.9742 329.112 82.5822 329.626 83.424C330.164 84.2658 330.433 85.2831 330.433 86.4757C330.433 88.0425 330.036 89.3403 329.241 90.3692C328.446 91.3748 327.346 92.1231 325.943 92.6142C324.564 93.1052 322.962 93.3508 321.138 93.3508Z"
        fill="#AE5714"
      />
      <path
        d="M59.4856 87.0849V87.5519H59.9526H77.9998H78.4669V87.0849V82.1665V81.6995H77.9998H69.4498C69.8882 81.1542 70.3831 80.6321 70.9354 80.1333L70.9359 80.1328C71.7778 79.3699 72.7259 78.5402 73.7806 77.6437L73.7806 77.6437L73.7847 77.6401C75.2328 76.3798 76.3381 75.1703 77.0838 74.0103L77.0838 74.0103L77.0865 74.0061C77.8535 72.7845 78.2289 71.3604 78.2289 69.7517C78.2289 66.9357 77.4194 64.686 75.7462 63.0695C74.0705 61.4506 71.6621 60.6775 68.5994 60.6775C67.1973 60.6775 65.7829 60.7988 64.3565 61.041L64.3565 61.041L64.355 61.0413C62.9602 61.2827 61.7299 61.5928 60.6674 61.9742L60.3582 62.0852V62.4138V67.9271V68.6099L60.9945 68.3624C61.9235 68.0011 62.9059 67.7037 63.9422 67.4705L63.9423 67.4706L63.953 67.4679C64.9739 67.2127 66.0068 67.0852 67.0525 67.0852C68.4067 67.0852 69.3366 67.3494 69.92 67.8007C70.4807 68.2345 70.7899 68.8951 70.7899 69.8706C70.7899 70.6589 70.6422 71.3084 70.3669 71.8361L70.3631 71.8433L70.3596 71.8507C70.1028 72.3876 69.6446 72.9761 68.9564 73.6133C68.2438 74.2731 67.28 75.1577 66.0645 76.2675C64.7361 77.4631 63.4997 78.6463 62.3554 79.8172L62.3554 79.8172L62.3516 79.8212C61.2066 81.0207 60.2666 82.3834 59.5319 83.9072L59.4856 84.0033V84.1101V87.0849Z"
        fill="#858486"
        stroke="url(#podium_paint11_linear)"
        strokeWidth="0.934119"
      />
      <defs>
        <linearGradient id="podium_paint0_linear" x1="20" y1="24" x2="127.5" y2="41" gradientUnits="userSpaceOnUse">
          <stop stopColor="#E3E2E2" />
          <stop offset="1" stopColor="#DFE1E8" />
        </linearGradient>
        <linearGradient id="podium_paint1_linear" x1="-1.5" y1="43.5" x2="130" y2="104" gradientUnits="userSpaceOnUse">
          <stop offset="0.0455341" stopColor="#D6D7DC" />
          <stop offset="0.988281" stopColor="#B4B6C5" />
        </linearGradient>
        <linearGradient
          id="podium_paint2_linear"
          x1="65.2372"
          y1="41.2031"
          x2="65.2372"
          y2="104.229"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CFC9DF" />
          <stop offset="1" stopColor="#808080" />
        </linearGradient>
        <linearGradient id="podium_paint3_linear" x1="354.5" y1="56" x2="271.5" y2="104" gradientUnits="userSpaceOnUse">
          <stop stopColor="#F6A55A" />
          <stop offset="0.550763" stopColor="#E7974D" />
          <stop offset="0.980211" stopColor="#D47D2D" />
        </linearGradient>
        <linearGradient
          id="podium_paint4_linear"
          x1="321.763"
          y1="57.9834"
          x2="321.763"
          y2="104.237"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFB850" />
          <stop offset="1" stopColor="#EB8C00" />
        </linearGradient>
        <linearGradient id="podium_paint5_linear" x1="128" y1="19.5" x2="261" y2="111" gradientUnits="userSpaceOnUse">
          <stop stopColor="#FFE76B" />
          <stop offset="0.374839" stopColor="#FFC700" />
          <stop offset="1" stopColor="#EFAC00" />
        </linearGradient>
        <linearGradient id="podium_paint6_linear" x1="194.5" y1="16" x2="194.5" y2="111" gradientUnits="userSpaceOnUse">
          <stop stopColor="#FFD800" />
          <stop offset="1" stopColor="#EB8C00" />
        </linearGradient>
        <linearGradient
          id="podium_paint7_linear"
          x1="262.5"
          y1="14.5"
          x2="130"
          y2="7.99999"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFDC5E" />
          <stop offset="1" stopColor="#FEED8D" />
        </linearGradient>
        <linearGradient
          id="podium_paint8_linear"
          x1="192.287"
          y1="38.2319"
          x2="192.287"
          y2="88.0002"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFD939" />
          <stop offset="0.253876" stopColor="#FFCA0B" />
          <stop offset="0.56118" stopColor="#FFE35B" />
          <stop offset="1" stopColor="#F3B301" />
        </linearGradient>
        <linearGradient
          id="podium_paint9_linear"
          x1="161.916"
          y1="45.8213"
          x2="161.916"
          y2="88.4027"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFD939" />
          <stop offset="0.253876" stopColor="#FFCA0B" />
          <stop offset="0.56118" stopColor="#FFE35B" />
          <stop offset="1" stopColor="#F3B301" />
        </linearGradient>
        <linearGradient
          id="podium_paint10_linear"
          x1="227.588"
          y1="46.1274"
          x2="227.588"
          y2="88.7089"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFD939" />
          <stop offset="0.253876" stopColor="#FFCA0B" />
          <stop offset="0.56118" stopColor="#FFE35B" />
          <stop offset="1" stopColor="#F3B301" />
        </linearGradient>
        <linearGradient
          id="podium_paint11_linear"
          x1="68.9762"
          y1="61.1445"
          x2="68.9762"
          y2="87.0849"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0507426" stopColor="#8A8B92" />
          <stop offset="0.483052" stopColor="#A8AABC" />
          <stop offset="1" stopColor="#5E5E5E" />
        </linearGradient>
      </defs>
    </Svg>
  )
}

export default Prizes
